import http from "../utils/http";

export function getAuditList(params) {
    return http({
        method: "post",
        url: "/system/sysParentsVisitApply/verify/paging",
        params
    });
}

export function auditInfo(params) {
    return http({
        method: "post",
        url: "/system/sysParentsVisitApply/verify",
        data:params
    });
}

